import Splide from '@splidejs/splide';

export default {
  init() {
    // JavaScript to be fired on the home page

    /**
     * Sets position of homepage heading
     */
    function homepageHeadingPosition(){
      const containerWidth = $('.banner-inner').eq(0).width();
      const windowWidth = $( window ).width();
      const margin = ((windowWidth - containerWidth) / 2);

      $('.home-slider aside').css('left', margin + 'px');
      $('.home-slider aside').css('padding-right', margin + 'px');
    }

    if($('#homepageSlider').length > 0){
      new Splide('#homepageSlider', {
        type   : 'loop',
        arrows: true,
        pagination: false,
        autoplay: true,
      }).mount();

      $(window).resize(function(){
        homepageHeadingPosition();
      });

      $(window).load(function(){
        homepageHeadingPosition();
      });
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js